module.exports = __webpack_public_path__ + "static/media/androidLogo.a109d31e.svg";